/// <amd-module name="SuiteCommerce.CookieConsent.Overlay.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.Overlay.Configuration", ["require", "exports", "SuiteCommerce.CookieConsent.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BannerPosition;
    (function (BannerPosition) {
        BannerPosition["TOP"] = "top";
        BannerPosition["BOTTOM"] = "bottom";
    })(BannerPosition || (BannerPosition = {}));
    var OverlayConfiguration = /** @class */ (function (_super) {
        __extends(OverlayConfiguration, _super);
        function OverlayConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(OverlayConfiguration, "bannerPosition", {
            get: function () {
                var selectedBannerPosition = this.get('cookieConsent.cookieBannerPosition');
                return BannerPosition[selectedBannerPosition] || 'top';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OverlayConfiguration, "bannerHeading", {
            get: function () {
                return this.get('cookieConsent.cookieBannerHeading') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OverlayConfiguration, "isFixedHeaderEnabled", {
            get: function () {
                return this.get('header.fixedHeader');
            },
            enumerable: true,
            configurable: true
        });
        return OverlayConfiguration;
    }(Configuration_1.Configuration));
    exports.OverlayConfiguration = OverlayConfiguration;
});
